<template>
  <main v-if="Object.keys(post).length">
    <top-section :title="post.title" :breadcrumb="breadcrumb" />
    <section class="blog_area single-post-area section-padding">
      <div class="container">
        <div class="row">
          <div class="col-12 posts-list">
            <div class="single-post">
              <div class="blog_details">
                <h2 style="color: #2d2d2d;">{{ post.title }}</h2>
                <div
                  v-if="post.contentImages.length <= 2"
                  class="feature-img__wrapper"
                >
                  <div
                    class="feature-img"
                    v-for="(url, i) in post.contentImages"
                    :key="i"
                  >
                    <img class="img-fluid" :src="url" :alt="post.title" />
                  </div>
                </div>
                <swiper
                  v-else
                  class="swiper post-slider mb-5"
                  ref="swiper"
                  :options="swiperOptions"
                >
                  <swiper-slide
                    class="team-active"
                    v-for="(url, i) in post.contentImages"
                    :key="i"
                  >
                    <img
                      style="max-width: 100%;"
                      :src="url"
                      :alt="post.title"
                    />
                  </swiper-slide>
                  <div class="swiper-button-prev" slot="button-prev"></div>
                  <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
                <p v-html="markdownConverter(post.content)"></p>
              </div>
            </div>
            <blog-author :url="post.author.avatar" :name="post.author.name" />
          </div>
        </div>
      </div>
    </section>
    <!-- Blog Area End -->
  </main>
</template>

<script>
import { getImgUrl } from "@/mixins/getImgUrl";
import marked from "marked";

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

import TopSection from "@/components/TopSection";
import BlogAuthor from "@/components/News/BlogAuthor";

export default {
  name: "SinglePost",
  components: { BlogAuthor, TopSection, Swiper, SwiperSlide },
  mixins: [getImgUrl],

  data: () => ({
    post: {},
    breadcrumb: [
      {
        title: "Головна",
        url: "/",
      },
      {
        title: "Новини",
        url: "/news",
      },
    ],
    nextPost: {},
    prevPost: {},
    swiperOptions: {
      spaceBetween: 15,
      slidesPerGroup: 1,
      loop: false,
      loopFillGroupWithBlank: true,
      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        1024: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
      },
    },
  }),

  async created() {
    if (!this.$store.getters.news.length) {
      await this.$store.dispatch("FETCH_NEWS");
    }

    this.post = this.$store.getters.news.find(
      (n) => n.id === this.$route.params.id
    );
  },
  methods: {
    markdownConverter(content) {
      return marked(content);
    },
  },
};
</script>

<style></style>
